(() => {
  'use strict';
  if (window.NovaCart?.__ready) return;
  const KIT_PRODUCT_ID = 10492117188924;
  const KIT_VARIANTS = new Set([54420797915452]);
  const roots = () => [...document.querySelectorAll('[data-ng-cart-drawer], [data-ng-cart-page]')];
  const drawer = () => document.querySelector('[data-ng-cart-drawer]');
  const overlay = () => document.querySelector('[data-ng-cart-overlay]');
  let cart = null;
  let queue = Promise.resolve();
  let pending = 0;
  let checkingOut = false;
  let requiresRefresh = false;
  const refreshMessage = 'We could not confirm your last bag update. Refresh this page to check your bag before adding more or checking out.';
  let lastMutationError = null;
  let previousFocus = null;
  let refreshVersion = 0;
  const escape = value => String(value ?? '').replace(/[&<>"']/g, character => ({'&':'&amp;', '<':'&lt;', '>':'&gt;', '"':'&quot;', "'":'&#39;'}[character]));
  const rootPath = () => String(window.Shopify?.routes?.root || window.NG?.routes?.root || '/').replace(/\/?$/, '/');
  const productUrl = () => `${rootPath()}products/novaglows-christmas-tree-lights`;
  function route(kind) {
    const config = window.NG?.routes || {};
    const names = {cart:['cart','cart_url','cartUrl'], add:['add','cart_add_url','cartAddUrl'], change:['change','cart_change_url','cartChangeUrl'], update:['update','cart_update_url','cartUpdateUrl']};
    const configured = names[kind].map(name => config[name]).find(Boolean);
    let path = String(configured || `${rootPath()}cart${kind === 'cart' ? '' : `/${kind}`}`);
    if (!/\.js(?:\?|$)/.test(path)) path = path.replace(/\/$/, '') + '.js';
    const url = new URL(path, window.location.origin);
    if (url.origin !== window.location.origin) throw new Error('The bag could not be loaded. Please refresh and try again.');
    return url.pathname + url.search;
  }
  function money(cents, currency = cart?.currency || window.NG?.currency || window.Shopify?.currency?.active || 'USD') {
    const code = typeof currency === 'string' ? currency : currency?.iso_code || 'USD';
    try { return new Intl.NumberFormat(document.documentElement.lang || 'en', {style:'currency', currency:code}).format(Number(cents || 0) / 100); }
    catch (_) { return `${(Number(cents || 0) / 100).toFixed(2)} ${code}`; }
  }
  function moneyWithCurrency(cents, currency = cart?.currency || window.NG?.currency || 'USD') {
    const code = typeof currency === 'string' ? currency : currency?.iso_code || 'USD';
    const amount = money(cents, code);
    return amount.includes(code) ? amount : `${amount} ${code}`;
  }
  const orderOptions = window.NovaOrderOptions;
  let priceData = {currency:'', variants:[]};
  try { priceData = JSON.parse(document.querySelector('[data-ng-cart-prices]')?.textContent || '{}'); } catch (_) {}
  (priceData.kitVariantIds || []).forEach(id => KIT_VARIANTS.add(Number(id)));
  const comparisonPrices = new Map((priceData.variants || []).map(variant => [Number(variant.id), Number(variant.compareAtPrice)]));
  function referenceLinePrice(item, currency) {
    const original = Number(item.original_line_price ?? item.line_price ?? 0);
    const compare = priceData.currency === currency ? comparisonPrices.get(Number(item.variant_id || item.id)) : 0;
    const quantity = Number(item.quantity);
    // Never mix currencies, infer a regular price, or replace Shopify's payable amount.
    return Number.isSafeInteger(compare) && compare > 0 && Number.isSafeInteger(quantity) && quantity > 0
      ? Math.max(original, compare * quantity) : original;
  }
  async function request(kind, body) {
    const options = {credentials:'same-origin', headers:{'Accept':'application/json','X-Requested-With':'XMLHttpRequest'}};
    if (body) { options.method = 'POST'; options.headers['Content-Type'] = 'application/json'; options.body = JSON.stringify(body); }
    else options.cache = 'no-store';
    let response;
    try { response = await fetch(route(kind), options); }
    catch (failure) { if (body) failure.requiresRefresh = true; throw failure; }
    const data = await response.json().catch(() => null);
    if (!response.ok || !data) {
      const message = data?.description || data?.message;
      const failure = new Error(typeof message === 'string' ? message : 'We could not update your bag. Please try again.');
      if (body && (!data || response.status >= 500 || response.status === 408)) failure.requiresRefresh = true;
      throw failure;
    }
    return data;
  }
  function error(message = '') {
    roots().forEach(root => root.querySelectorAll('[data-ng-cart-error]').forEach(element => { element.textContent = message; element.hidden = !message; }));
  }
  function announce(message) { roots().forEach(root => { const status = root.querySelector('[data-ng-cart-status]'); if (status) status.textContent = message; }); }
  const isKit = item => Number(item.product_id) === KIT_PRODUCT_ID || KIT_VARIANTS.has(Number(item.variant_id || item.id));
  const eligibleCount = value => (value.items || []).filter(isKit).reduce((sum,item) => sum + Number(item.quantity), 0);
  async function syncCheckoutSavings(value) {
    // Remove the old informational label; Shopify now renders the actual discount.
    const updates = (value.items || []).filter(item => isKit(item) && item.properties?.['Kit savings']).map(item => ({id:item.key, quantity:item.quantity, properties:{...item.properties, 'Kit savings':''}}));
    for (const update of updates) value = await request('change', update);
    return value;
  }
  async function syncGiftAttributes(value) {
    const count = eligibleCount(value);
    const expected = count >= 2 ? '1 star topper and 1 spare extension set' : count >= 1 ? '1 free mystery gift' : '';
    if (String(value.attributes?.['Included gifts'] || '') === expected) return value;
    return request('update', {attributes:{...(value.attributes || {}), 'Included gifts':expected}});
  }
  function busy() {
    roots().forEach(root => {
      root.setAttribute('aria-busy', pending || checkingOut ? 'true' : 'false');
      root.querySelectorAll('[data-ng-cart-adjust], [data-ng-cart-quantity], [data-ng-cart-checkout]').forEach(control => {
        control.disabled = Boolean(pending || checkingOut || (control.matches('[data-ng-cart-checkout]') && !cart?.item_count));
      });
      root.querySelectorAll('[data-ng-cart-remove]').forEach(control => control.setAttribute('aria-disabled', pending || checkingOut ? 'true' : 'false'));
    });
  }
  function lineMarkup(item, index, scope) {
    if (orderOptions?.typeOf(item)) return orderOptions.lineMarkup(item, {escape, money});
    const image = item.featured_image?.url || item.image;
    const title = item.product_title || item.title;
    const variant = item.variant_title && item.variant_title !== 'Default Title' ? `<p class="ngc-item__variant">${escape(item.variant_title)}</p>` : '';
    const properties = Object.entries(item.properties || {}).filter(([key,value]) => !key.startsWith('_') && key.trim().toLowerCase() !== 'pack' && value).map(([key,value]) => `<p class="ngc-item__property">${escape(key)}: ${escape(value)}</p>`).join('');
    const original = referenceLinePrice(item, cart.currency);
    const final = Number(item.final_line_price ?? item.line_price);
    const lineSavings = Math.max(0, original - final);
    const discounts = (item.line_level_discount_allocations || []).map(allocation => `<span class="ngc-sr-only">${escape(allocation.discount_application?.title || 'Kit savings')}</span>`).join('');
    const url = item.url || productUrl();
    const key = escape(item.key);
    const inputId = `ngc-quantity-${scope}-${index}`;
    return `<article class="ngc-item" data-ng-cart-line="${key}">
      <a class="ngc-item__image" href="${escape(url)}">${image ? `<img src="${escape(image)}" alt="${escape(title)}" loading="lazy" width="110" height="138">` : ''}</a>
      <div class="ngc-item__details"><a class="ngc-item__title" href="${escape(url)}">${escape(title)}</a>${variant}${properties}</div>
      <button type="button" data-ng-cart-remove data-key="${key}" class="ngc-remove" aria-label="Remove ${escape(title)}"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M4 7h16M9 7V4h6v3M6 7l1 13h10l1-13M10 10v7M14 10v7"/></svg></button>
      <div class="ngc-item__controls"><div class="ngc-quantity"><button type="button" data-ng-cart-adjust="-1" data-key="${key}" aria-label="Decrease quantity for ${escape(title)}">&minus;</button><label class="ngc-sr-only" for="${inputId}">Quantity for ${escape(title)}${item.variant_title && item.variant_title !== 'Default Title' ? `, ${escape(item.variant_title)}` : ''}</label><input type="number" id="${inputId}" name="updates[]" value="${item.quantity}" min="0" inputmode="numeric" data-ng-cart-quantity data-key="${key}"><button type="button" data-ng-cart-adjust="1" data-key="${key}" aria-label="Increase quantity for ${escape(title)}">+</button></div></div>
      <div class="ngc-item__price">${lineSavings ? `<s aria-label="Regular price">${escape(money(original))}</s>` : ''}<strong>${escape(money(final))}</strong>${lineSavings ? `<span class="ngc-item__save">You save ${escape(money(lineSavings))}</span>` : ''}${discounts}</div>
    </article>`;
  }
  function emptyMarkup() {
    return `<div class="ngc-empty"><span class="ngc-empty__spark" aria-hidden="true">&#10022;</span><h2>A little magic is waiting.</h2><p>Your bag is empty. Find the lights that make your tree feel brand new.</p><a class="ngc-checkout" href="${escape(productUrl())}">Discover the light kit <span aria-hidden="true">&rarr;</span></a></div>`;
  }
  function render(nextCart) {
    cart = nextCart;
    const count = eligibleCount(cart);
    const comparisonTotal = (cart.items || []).reduce((sum,item) => sum + referenceLinePrice(item, cart.currency), 0);
    const savings = Math.max(0, comparisonTotal - Number(cart.total_price));
    roots().forEach((root, scope) => {
      const focused = root.contains(document.activeElement) ? document.activeElement?.closest('[data-ng-cart-line]') : null;
      const focusedKey = focused?.dataset.ngCartLine;
      const focusedType = focused ? (document.activeElement.matches('[data-ng-cart-quantity]') ? 'quantity' : document.activeElement.getAttribute('data-ng-cart-adjust')) : null;
      const items = root.querySelector('[data-ng-cart-items]');
      if (items) items.innerHTML = cart.item_count ? cart.items.map((item,index) => lineMarkup(item,index,scope)).join('') : emptyMarkup();
      root.querySelectorAll('[data-ng-cart-total]').forEach(element => { element.textContent = moneyWithCurrency(cart.total_price); });
      root.querySelectorAll('[data-ng-cart-compare]').forEach(element => { element.hidden = !savings; element.textContent = savings ? money(comparisonTotal) : ''; });
      root.querySelectorAll('[data-ng-cart-savings]').forEach(element => { element.hidden = !savings; element.textContent = `-${money(savings)}`; });
      root.querySelectorAll('[data-ng-cart-before-row], [data-ng-cart-savings-row]').forEach(element => { element.hidden = !savings; });
      root.querySelectorAll('[data-ng-cart-gifts]').forEach(element => { element.innerHTML = count >= 2 ? '<div class="ngc-gifts"><span aria-hidden="true">&#10022;</span><div><strong>Your free gifts are included</strong><p>One star topper and one spare extension set with your light kits. Your mystery gift is included in this bundle.</p></div></div>' : count >= 1 ? '<div class="ngc-gifts"><span aria-hidden="true">🎁</span><div><strong>Free mystery gift included</strong><p>One free mystery gift with your light kit.</p></div></div>' : ''; });
      root.querySelectorAll('[data-ng-cart-summary], .ngc-drawer__footer').forEach(element => { element.hidden = !cart.item_count; });
      if (focusedKey && focusedType) {
        const line = [...root.querySelectorAll('[data-ng-cart-line]')].find(element => element.dataset.ngCartLine === focusedKey);
        const control = line?.querySelector(focusedType === 'quantity' ? '[data-ng-cart-quantity]' : `[data-ng-cart-adjust="${focusedType}"]`);
        if (control) requestAnimationFrame(() => { if (!control.disabled) control.focus({preventScroll:true}); });
      }
    });
    document.querySelectorAll('[data-ng-cart-count]').forEach(element => { element.textContent = cart.item_count; element.hidden = !cart.item_count; });
    busy();
    document.dispatchEvent(new CustomEvent('nova:cartupdated', {detail:{cart}}));
  }
  async function refresh() {
    const version = ++refreshVersion;
    const nextCart = await request('cart');
    if (version === refreshVersion) render(nextCart);
    return nextCart;
  }
  function mutate(action, message) {
    pending += 1;
    busy();
    const operation = queue.catch(() => {}).then(async () => {
      let actionApplied = false;
      error();
      lastMutationError = null;
      refreshVersion += 1;
      try {
        if (requiresRefresh) throw Object.assign(new Error(refreshMessage), {requiresRefresh:true});
        if (window.NG?.localizationPending) throw new Error('Your country is updating. Please wait a moment.');
        let nextCart = await action();
        actionApplied = true;
        if (orderOptions) nextCart = await orderOptions.normalize(nextCart, request);
        nextCart = await syncGiftAttributes(nextCart);
        render(nextCart);
        announce(typeof message === 'function' ? message(nextCart) : message);
        return nextCart;
      } catch (failure) {
        if (failure.requiresRefresh || actionApplied) {
          requiresRefresh = true;
          failure.message = refreshMessage;
        }
        lastMutationError = failure;
        error(failure.message || 'We could not update your bag. Please try again.');
        announce(requiresRefresh ? refreshMessage : 'Your bag was not updated. Please try again.');
        throw failure;
      } finally { pending -= 1; busy(); }
    });
    queue = operation.catch(() => {});
    return operation;
  }
  function add(item, {openDrawer = true} = {}) {
    if (requiresRefresh) return Promise.reject(new Error(refreshMessage));
    if (window.NG?.localizationPending) return Promise.reject(new Error('Your country is updating. Please wait a moment.'));
    if (checkingOut) return Promise.reject(new Error('Checkout is opening. Please wait a moment.'));
    // Send all selected tree sizes in one Shopify add request, retaining single-item callers.
    const selectedItems = Array.isArray(item?.items) ? item.items : [item];
    if (!selectedItems.length || selectedItems.some(selected => !Number.isSafeInteger(Number(selected?.id)) || Number(selected.id) <= 0 || !Number.isSafeInteger(Number(selected?.quantity ?? 1)) || Number(selected?.quantity ?? 1) < 1)) return Promise.reject(new Error('Choose a size and quantity before adding to your bag.'));
    const items = selectedItems.map(selected => ({id:Number(selected.id), quantity:Number(selected.quantity ?? 1), ...(selected.properties ? {properties:selected.properties} : {})}));
    return mutate(async () => {
      if (orderOptions) {
        const current = await request('cart');
        orderOptions.prepareAdd(current, items, item.orderOptions);
      }
      await request('add', {items});
      try { return await request('cart'); }
      catch (failure) { failure.requiresRefresh = true; throw failure; }
    }, 'Your light kits have been added to your bag.').then(async nextCart => { if (openDrawer) await open(); return nextCart; });
  }
  function setQuantity(key, quantity) {
    if (requiresRefresh) return Promise.reject(new Error(refreshMessage));
    if (checkingOut) return Promise.reject(new Error('Checkout is opening. Please wait a moment.'));
    const amount = Number(quantity);
    if (amount > 1 && orderOptions?.typeOf(cart?.items?.find(item => item.key === key))) return Promise.reject(new Error('Each optional extra is charged once per order.'));
    if (!Number.isSafeInteger(amount) || amount < 0) return Promise.reject(new Error('Enter a whole number of kits.'));
    return mutate(() => request('change', {id:key, quantity:amount}), amount ? 'Your bag quantity has been updated.' : 'The item has been removed from your bag.');
  }
  async function open() {
    const panel = drawer();
    if (!panel) { window.location.assign(`${rootPath()}cart`); return; }
    if (panel.hidden) previousFocus = document.activeElement;
    panel.hidden = false;
    if (overlay()) overlay().hidden = false;
    document.body.classList.add('ngc-is-open');
    document.querySelectorAll('[data-ng-cart-open]').forEach(button => button.setAttribute('aria-expanded','true'));
    panel.querySelector('[data-ng-cart-close]')?.focus({preventScroll:true});
    try { await mutate(() => request('cart'), 'Your bag is up to date.'); }
    catch (failure) { error(failure.message); }
  }
  function close() {
    if (drawer()) drawer().hidden = true;
    if (overlay()) overlay().hidden = true;
    document.body.classList.remove('ngc-is-open');
    document.querySelectorAll('[data-ng-cart-open]').forEach(button => button.setAttribute('aria-expanded','false'));
    if (previousFocus?.isConnected) previousFocus.focus({preventScroll:true});
  }
  document.addEventListener('click', event => {
    const opener = event.target.closest('[data-ng-cart-open]');
    if (opener) { event.preventDefault(); open(); return; }
    if (event.target.closest('[data-ng-cart-close], [data-ng-cart-overlay]')) { event.preventDefault(); close(); return; }
    const action = event.target.closest('[data-ng-cart-adjust], [data-ng-cart-remove]');
    if (!action || !action.closest('[data-ng-cart-drawer], [data-ng-cart-page]')) return;
    event.preventDefault();
    if (pending || checkingOut) return;
    const key = action.dataset.key;
    const item = cart?.items.find(item => item.key === key);
    const current = item?.quantity ?? Number(action.closest('[data-ng-cart-line]')?.querySelector('[data-ng-cart-quantity]')?.value || 0);
    const next = action.matches('[data-ng-cart-remove]') ? 0 : Math.max(0, current + Number(action.dataset.ngCartAdjust));
    setQuantity(key,next).catch(() => {});
  });
  document.addEventListener('change', event => {
    if (!event.target.matches('[data-ng-cart-quantity]')) return;
    const input = event.target;
    if (pending || checkingOut) return;
    const quantity = Number(input.value);
    if (!Number.isSafeInteger(quantity) || quantity < 0 || input.value.trim() === '') { error('Enter a whole number of kits.'); input.value = cart?.items.find(item => item.key === input.dataset.key)?.quantity || 1; return; }
    setQuantity(input.dataset.key,quantity).catch(() => {});
  });
  async function checkout(form) {
    if (requiresRefresh) throw new Error(refreshMessage);
    if (window.NG?.localizationPending) throw new Error('Your country is updating. Please wait a moment.');
    if (checkingOut) throw new Error('Checkout is opening. Please wait a moment.');
    checkingOut = true;
    busy();
    try {
      await queue;
      if (lastMutationError) throw new Error(requiresRefresh ? refreshMessage : 'Please retry the last bag update before checkout.');
      let latest = await refresh();
      if (!latest.item_count) throw new Error('Your bag is empty. Please choose a kit.');
      if (window.NG?.localizationPending) throw new Error('Your country is updating. Please wait a moment.');
      const selectedCurrency = typeof window.NG?.currency === 'string' ? window.NG.currency : window.NG?.currency?.iso_code;
      if (selectedCurrency && latest.currency && selectedCurrency !== latest.currency) {
        throw new Error('Your currency has changed. Refresh this page before checkout so all prices match.');
      }
      latest = await syncCheckoutSavings(latest);
      if (orderOptions) latest = await orderOptions.normalize(latest, request);
      latest = await syncGiftAttributes(latest);
      render(latest);
      if (orderOptions) {
        const validationError = orderOptions.checkoutError(latest);
        if (validationError) throw new Error(validationError);
      }
      form.querySelectorAll('[data-ng-cart-checkout]').forEach(button => { button.disabled = true; });
      // Preserve Shopify's native cart POST checkout flow and its current country session.
      const checkout = document.createElement('input');
      checkout.type = 'hidden'; checkout.name = 'checkout'; checkout.value = 'Checkout'; form.append(checkout);
      HTMLFormElement.prototype.submit.call(form);
    } catch (failure) { if (failure.requiresRefresh) requiresRefresh = true; error(requiresRefresh ? refreshMessage : failure.message); checkingOut = false; busy(); throw failure; }
  }

  async function buyNow(item) {
    await add(item, {openDrawer:false});
    const form = document.createElement('form');
    form.method = 'post';
    form.action = route('cart').replace(/\.js(?=\?|$)/, '');
    form.hidden = true;
    document.body.append(form);
    try { await checkout(form); }
    catch (failure) {
      form.remove();
      failure.kitAdded = true;
      throw failure;
    }
  }
  document.addEventListener('submit', async event => {
    const form = event.target;
    if (!form.matches('[data-ng-cart-checkout-form], [data-ng-cart-page-form]') || event.submitter?.name !== 'checkout') return;
    event.preventDefault();
    try { await checkout(form); } catch (failure) { error(requiresRefresh ? refreshMessage : failure.message); }
  });
  document.addEventListener('keydown', event => {
    const panel = drawer();
    if (!panel || panel.hidden) return;
    if (event.key === 'Escape') { event.preventDefault(); close(); return; }
    if (event.key !== 'Tab') return;
    const focusable = [...panel.querySelectorAll('a[href],button:not([disabled]),input:not([disabled]),[tabindex="0"]')].filter(element => element.getClientRects().length && !element.closest('[hidden]'));
    if (!focusable.length) { event.preventDefault(); panel.focus(); return; }
    const first = focusable[0], last = focusable[focusable.length - 1];
    if (event.shiftKey && (document.activeElement === first || !panel.contains(document.activeElement))) { event.preventDefault(); last.focus(); }
    else if (!event.shiftKey && (document.activeElement === last || !panel.contains(document.activeElement))) { event.preventDefault(); first.focus(); }
  });
  window.NovaCart = {__ready:true, add, buyNow, open, close, refresh, setQuantity, getCart:() => cart, isBusy:() => pending > 0 || checkingOut, requiresRefresh:() => requiresRefresh};
  function init() {
    document.querySelectorAll('[data-ng-cart-open]').forEach(button => { button.setAttribute('aria-haspopup','dialog'); button.setAttribute('aria-expanded','false'); });
    if (document.querySelector('[data-ng-product]')) refresh().catch(() => {});
    if (document.querySelector('[data-ng-cart-page]')) mutate(() => request('cart'), 'Your bag is up to date.').catch(failure => error(failure.message));
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',init,{once:true}); else init();
})();
